import React from 'react';

import {
  PHOTO_ID_MASK_PREFIX,
  REGISTRATION_ROLE_CODES
} from 'pages/users/containers/usersContainer/components/registrationData/columns';

const RegistrationDataRow = ({ columns, row }) => {
  const roleClass = REGISTRATION_ROLE_CODES.includes(row.role) ? row.role : 'support_user';

  return (
    <tr>
      {columns.map(({ key }) => {
        let value = row[key] ?? '';
        if (key === 'photo_id_number' && value) {
          value = `${PHOTO_ID_MASK_PREFIX}${value}`;
        }
        return (
          <td key={key} className="align-middle" data-title={key} title={String(value)}>
            {key === 'role_label'
              ? value && <span className={`registration-role-pill ${roleClass}`}>{value}</span>
              : value}
          </td>
        );
      })}
    </tr>
  );
};

export default RegistrationDataRow;
